import * as React from "react";
import MainLayout from "./MainLayout/MainLayout";
import { Switch, Route, Redirect } from "react-router";
import Settings from "./Settings/Settings";
import Admin from "./Admin/Admin";
import ActivityListing from "../containers/ActivityListing/ActivityListing";
import Profile from "../containers/Profile/Profile";
import ActivityDetails from "./ActivityDetails/ActivityDetails";
import RestrictedRoute from "../containers/RestrictedRoute";
import ExerciseSelector from "../containers/ExerciseSelector/ExerciseSelector";
import ExerciseWithGlobalBluetooth from "../containers/Exercise/ExerciseWithGlobalBluetooth";
import WorkoutListing from "../containers/WorkoutListing/WorkoutListing";
import WorkoutDetails from "../pages/WorkoutDetails/WorkoutDetails";
import ExerciseManager from "../containers/ExerciseManager/ExerciseManager";
import Flappybird from "../flappybird/flappybird";
import { State } from "../reducers";
import i18n from "../i18n";
import { connect } from "react-redux";
import { Lang } from "../types";
import ExerciseCreator from "./exerciseCreator/ExerciseCreator";
import Hangboard from "../components/Hangboard/Hangboard";

const mapStatetoProps = (state: State, ownProps: any) => {
  if(state.authentication.user !== undefined)
    return({lang: state.authentication.user.displaySettings.lang});
  return({lang: 'en'})
}
interface HomeProps {
  lang: Lang;
}
class Home extends React.Component<HomeProps, {}> {
  componentDidMount(){
    // Set initial language
    i18n.changeLanguage(this.props.lang);
  }
  
  componentDidUpdate(prevProps: HomeProps) {
    // Update language if it changed
    if (prevProps.lang !== this.props.lang) {
      i18n.changeLanguage(this.props.lang);
    }
  }
  
  render() {
    // Only request wake lock if page is visible and focused
    if ("wakeLock" in navigator && document.visibilityState === 'visible' && document.hasFocus()) {
      try {
        (navigator as any).wakeLock.request("screen");
      } catch (error) {
        console.log('WakeLock request failed:', error);
      }
    }
    return (
      <MainLayout>
        <Switch>
          <RestrictedRoute
            path="/admin"
            requiredRole="admin"
            component={Admin}
          />
          <Route path="/profile" component={Profile} />
          <Route path="/activities/:id" component={ActivityDetails} />
          <Route
            exact={true}
            path="/athletes/:id/profile"
            component={Profile}
          />
          <Route path="/athletes/:id/activities" component={ActivityListing} />
          <Route path="/exercise-launcher" component={WorkoutListing} />
          <Route path="/exercise" component={ExerciseWithGlobalBluetooth} />
          <Route path="/workouts/:workout" component={WorkoutDetails} />
          <Route path="/settings" component={Settings} />
          <Route path="/exercise-creator" component={ExerciseCreator} />
          <Route path="/raw" component={ExerciseSelector} />
          <Route path="/exercisemanager" component={ExerciseManager} />
          <Route path="/flappybird" component={Flappybird} />
          <Route path="/hangboard" component={Hangboard} />
          <Route exact path="/" render={() => <Redirect to="/exercise-launcher" />} />
        </Switch>
      </MainLayout>
    );
  }
}

export default connect(mapStatetoProps)(Home);
